import React from "react";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import PaymentSuccess from "./pages/PaymentSuccess";
import ThankYou from "./pages/ThankYou";
import { Toaster } from "./components/ui/sonner";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const StoreLayout = () => (
  <>
    <Header />
    <CartDrawer />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products/:handle" element={<Product />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/thankyou" element={<ThankYou />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms" element={<Legal docKey="terms" />} />
      <Route path="/privacy" element={<Legal docKey="privacy" />} />
    </Routes>
    <Footer />
    <ChatWidget />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollManager />
          <Routes>
            <Route path="/admin16" element={<Admin />} />
            <Route path="/*" element={<StoreLayout />} />
          </Routes>
          <Toaster position="top-center" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
